import type { Organization, OrganizationGetCommand } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';
import { assertNonEmptyString } from './_utils';

export class GetOrganizationUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(command: OrganizationGetCommand): Promise<Organization> {
    assertNonEmptyString(command.organization_id, 'organization_id');
    return this.repository.getOrganization(command);
  }
}


